import { Pipe, PipeTransform } from '@angular/core';
import { availableLocales } from '@locale/config/available-locales';

@Pipe({
  name: 'localeFlag',
  standalone: true,
})
export class LocaleFlagPipe implements PipeTransform {
  transform(localeCode: string): string {
    return availableLocales.find((locale) => locale.code === localeCode)?.flag || localeCode;
  }
}
